<template>
  <div class="LoadingTo"></div>
</template>

<script>
export default {
  name: "LoadingTo",
  async created() {
    location.href = "/login";
    }
};
</script>